import React from 'react';
import { Link } from 'react-router-dom';
import FooterLayoutComponent from '../common/layout/FooterLayoutComponent';

const StyleFabricListComponent = props => {
    const { category } = props
    return (
        <main className="style">
            <div className="body">
                <div className="head">
                    <div className="title">
                        STYLE & FABRIC
                            </div>
                    {category ?
                        <nav className="lnb">
                            <ul>
                                <li>
                                    <a>{category.parent.names['en']}</a>
                                </li>
                                <li>
                                    <a>{category.names['en']}</a>

                                </li>
                            </ul>
                        </nav>
                        : null}
                </div>
                <section className="style-list">
                    <div className="list">
                        <ul>
                            {props.list.map((item, idx) =>
                                <li>
                                    <Link
                                        to={`/style-fabric/${item.id}`}
                                        className="item">
                                        <div className="img">
                                        {item.thumbnailImageObj?
                                            <img
                                                src={item.thumbnailImageObj.url}
                                                alt={item.name}
                                            />
                                        :
                                            <img
                                                src={item.imageUrlList[0]}
                                                alt={item.name}
                                            />
                                        }
                                        </div>
                                        <div className="info">
                                            <div className="name">{item.name}</div>
                                            <div className="num">
                                                {item.fabric}
                                            </div>
                                        </div>
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>
                </section>
            </div>
            <FooterLayoutComponent
                {...props} />
        </main>
    )
}

export default StyleFabricListComponent;